import React from 'react';
import styled, { css } from 'styled-components';

interface ModalContentProps {
  children?: React.ReactNode;
  className?: string;
  textAlign?: string;
}

const Layout = styled.section<Partial<ModalContentProps>>`
  position: relative;
  flex-grow: 1;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: auto;

  ${({ textAlign }) =>
    textAlign &&
    css`
      text-align: ${textAlign};
    `}
`;

const ModalContent: React.FC<ModalContentProps> = ({ textAlign, children, className }) => (
  <Layout textAlign={textAlign} className={className} data-cy="modal-content">
    {children}
  </Layout>
);

export default ModalContent;
